import React, {Component} from 'react';
import {config, SERVICE_API, VIEW_NAME, DISPATCH_ID} from '../libs/utils/Const';
import {connect} from "react-redux";
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';
import {BreadCrumb} from './index'
import "./ItemSlider.css";
import { Redirect } from 'react-router';

class SideBarItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataCategories: {
                itemsFamilia: [], // Inicializa itemsFamilia como un array vacío u otros valores iniciales según tu lógica
            },
            showVerMasFamilia: true,
            cantidadMostradaFamilia: 10,
            additionalToShowFamilia: 10,
            showVerMasCategoria: true,
            cantidadMostradaCategoria: 10,
            additionalToShowCategoria: 10,
        };
    }

    seeAllCategories = ()=>{
        $('#filterCategoriesModal').modal('show');
    }

    handleVerMasFamilia = () => {
        const { dataCategories } = this.props;
    
        if (dataCategories && dataCategories.itemsFamilia) {
            this.setState((prevState) => ({
                cantidadMostradaFamilia: Math.min(prevState.cantidadMostradaFamilia + prevState.additionalToShowFamilia, dataCategories.itemsFamilia.length),
            }));
        }
    };
    
    
    handleVerMenosFamilia = () => {
        this.setState((prevState) => ({
            cantidadMostradaFamilia: Math.max(prevState.cantidadMostradaFamilia - prevState.additionalToShowFamilia, 10),
        }));
    };


        // Función para mostrar más categorías
        handleVerMasCategoria = () => {
            const { dataCategories } = this.props; // Asegúrate de obtener dataCategories desde las props

            if (dataCategories && dataCategories.itemsCategoria) {
                this.setState((prevState) => ({
                    cantidadMostradaCategoria: Math.min(prevState.cantidadMostradaCategoria + prevState.additionalToShowCategoria, dataCategories.itemsCategoria.length),
                }));
            }
        };

        // Función para mostrar menos categorías
        handleVerMenosCategoria = () => {
            this.setState((prevState) => ({
                cantidadMostradaCategoria: Math.max(prevState.cantidadMostradaCategoria - prevState.additionalToShowCategoria, 10),
            }));
        };



    uniqueFilter = async (property, value, value2) => {
        const {itemsReducer, setItemsFilters, viewOne } = this.props;
        let data = {property : property, value : value, value2, value2}
        // Nueva variable de redux para guardar filtro
        setItemsFilters(data);
        setTimeout(async() => {
            // Ejecutar searchByKey
            if(viewOne && viewOne !== ''){
                await itemsReducer.searchByKey(0, viewOne);
            } else {
                await itemsReducer.searchByKey();
            }  
        }, 350);    
        $('#filterCategoriesModal').modal('hide');
    };

    render() {
        const { totalRows, dataCategories } = this.props;

        // Variable que limita no. de caracteres de nombre de categorías
        let categoryStringLimiter = 20;
        let guardar, contador = 0;
        // Limitante de categorias mostradas en SideBar
        let limitNumber = 10;
        // Modal de categorias
        let twoColumns = dataCategories ? dataCategories.itemsCategories ? dataCategories.itemsCategories.length >= 10 ? Number(((dataCategories.itemsCategories.length + 9) / 2).toFixed(0)) : dataCategories.itemsCategories.length : 0 : 0;
        if(!dataCategories || !dataCategories.itemsCategories){
            return <Redirect to="/"/>;
        } else {
            return (
                <div>
                    {/* <div> <BreadCrumb data={dataCategories.itemsCategories ? dataCategories.itemsCategories : []}/></div> */}
                    <div className="text-black" >{totalRows > 1 ? totalRows+' resultados': totalRows+' resultado' }</div>
                    {/* Categorías */}
                    {/* {(!!dataCategories.itemsCategories && dataCategories.itemsCategories.length > 0) && 
                        <h5 className="mt-md-5 font-weight-bold TituloCategoria" >Categorías</h5>
                    }
                    {(!!dataCategories.itemsCategories && dataCategories.itemsCategories.length > 0) && 
                        <ul className = "mt-2 SubCategorias" style={{paddingLpaddingLeft: "12px", color: "white"}}>
                            <dl>
                                {!!dataCategories.itemsCategories && dataCategories.itemsCategories.map((category, index) => {
                                    if(index < limitNumber){
                                        if(category.category.includes(',')){
                                            let categoryNameArray = category.categoryName.split(',');
                                            let length = categoryNameArray.length;
                                            let containerReturn = [];
                                            for (let i = 0; i < categoryNameArray.length; i++) {
                                                let dinamicCategory = categoryNameArray[i].substring(0, categoryStringLimiter);
                                                containerReturn.push(<dd >{(i == 0) && dinamicCategory}
                                                    {((i > 0 && i < (length - 1))) && <ol> {dinamicCategory} </ol>}
                                                    {(i == (length - 1)) && <ol className = 'linkFilter' className = 'linkFilter' onClick = {() => this.uniqueFilter('categorias', category.categoSearch, '')}>
                                                        {dinamicCategory} ({category.times})
                                                    </ol>}
                                                </dd>);
                                            }
                                            return containerReturn;
                                        } else {
                                            return <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('categorias', category.categoSearch, '')}>
                                                    {category.categoryName} ({category.times})
                                                </dd>
                                        }
                                    }
                                })}
                                {dataCategories && dataCategories.itemsCategories.length > 0 && dataCategories.itemsCategories.length >= 10 &&
                                 <dd className = 'linkFilter font-weight-bold' onClick={()=> this.seeAllCategories()}> Ver todas las categorías </dd>}
                            </dl>
                        </ul>
                    } */}
                    {/* Marcas */}
                    {/* {(dataCategories && dataCategories.itemsMarca.length > 0) && 
                        <h5 className="mt-md-4 font-weight-bold TituloCategoria" >Marca</h5>
                    }
                    {(dataCategories && dataCategories.itemsMarca.length > 0) && 
                        <ul className = "mt-2 SubCategorias" style={{paddingLeft:"12px"}}>
                            <dl>
                                {dataCategories.itemsMarca.map(brand => {
                                    return  <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('marca', brand.code, '')}>
                                                {brand.brand} ({brand.times})
                                            </dd>
                                })}
                            </dl>
                        </ul>
                    } */}
                    {/* Familia */}
                    {dataCategories && dataCategories.itemsFamilia.length > 0 && (
                        <div>
                            <h5 className="mt-md-4 font-weight-bold TituloCategoria">Familia </h5>
                            <ul className = "mt-2 SubCategorias" style={{paddingLeft:"12px"}}>
                                <dl>
                                    {dataCategories.itemsFamilia.slice(0, this.state.cantidadMostradaFamilia).map(brand => (
                                        <dd className='linkFilter' key={brand.code} onClick={() => this.uniqueFilter('familia', brand.code, '')}>
                                            <i className="fa fa-home" aria-hidden="true"></i> {brand.brand}
                                        </dd>
                                    ))}
                                </dl>
                            </ul>
                            {this.state.showVerMasFamilia && this.state.cantidadMostradaFamilia < dataCategories.itemsFamilia.length && (
                        <label style={{ color: "rgb(190, 24, 36)", cursor: 'pointer', marginRight: '10px' }} onClick={this.handleVerMasFamilia}>
                            <strong> Ver más</strong>
                        </label>
                    )}

                            {this.state.cantidadMostradaFamilia > 10 && (
                                <label style={{ color: "rgb(190, 24, 36)", cursor: 'pointer', marginRight: '10px' }} onClick={this.handleVerMenosFamilia}>
                                    <strong> Ver menos</strong>
                                </label>
                            )}
                        </div>
                    )}

                    {/* Categoria */}
                    {(dataCategories && dataCategories.itemsCategoria.length > 0) && (
                        <div>
                            <h5 className="mt-md-4 font-weight-bold TituloCategoria">Categoria</h5>
                            <ul className="mt-2 SubCategorias" style={{ paddingLeft: "12px" }}>
                                <dl>
                                    {dataCategories.itemsCategoria.slice(0, this.state.cantidadMostradaCategoria).map(brand => (
                                        <dd className='linkFilter' key={brand.code} onClick={() => this.uniqueFilter('categoria', brand.code, '')}>
                                            <i className="fa fa-th" aria-hidden="true"></i> {brand.brand}
                                        </dd>
                                    ))}
                                </dl>
                            </ul>
                            {this.state.showVerMasCategoria && this.state.cantidadMostradaCategoria < dataCategories.itemsCategoria.length && (
                                <label style={{ color: "rgb(190, 24, 36)", cursor: 'pointer', marginRight: '10px' }} onClick={this.handleVerMasCategoria}>
                                    <strong> Ver más</strong>
                                </label>
                            )}
                            {this.state.cantidadMostradaCategoria > 10 && (
                                <label style={{ color: "rgb(190, 24, 36)", cursor: 'pointer', marginRight: '10px' }} onClick={this.handleVerMenosCategoria}>
                                    <strong> Ver menos</strong>
                                </label>
                            )}
                        </div>
                    )}

                    {/* Temperatura */}
                    {/* {(dataCategories && dataCategories.itemsTemperatura.length > 0) && 
                        <h5 className="mt-md-4 font-weight-bold TituloCategoria">Temperatura</h5>
                    }
                    {(dataCategories && dataCategories.itemsTemperatura.length > 0) && 
                        <ul className = "mt-2 SubCategorias" style={{paddingLeft:"12px"}}>
                            <dl>
                                {dataCategories.itemsTemperatura.map(brand => {
                                    return  <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('temperatura', brand.code, '')}>
                                                {brand.brand} ({brand.times})
                                            </dd>
                                })}
                            </dl>
                        </ul>
                    } */}
                    {/* Procedencia */}
                    {/* {(dataCategories && dataCategories.itemsProcedencia.length > 0) && 
                        <h5 className="mt-md-4 font-weight-bold TituloCategoria">Procedencia</h5>
                    }
                    {(dataCategories && dataCategories.itemsProcedencia.length > 0) && 
                        <ul className = "mt-2 SubCategorias" style={{paddingLeft:"12px"}}>
                            <dl>
                                {dataCategories.itemsProcedencia.map(brand => {
                                    return  <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('procedencia', brand.code, '')}>
                                                {brand.brand} ({brand.times})
                                            </dd>
                                })}
                            </dl>
                        </ul>
                    } */}
                    {/* Unidad */}
                    {/* {(dataCategories && dataCategories.itemsUnidad.length > 0) && 
                        <h5 className="mt-md-4 font-weight-bold TituloCategoria">Unidad</h5>
                    }
                    {(dataCategories && dataCategories.itemsUnidad.length > 0) && 
                        <ul className = "mt-2 SubCategorias" style={{paddingLeft:"12px"}}>
                            <dl>
                                {dataCategories.itemsUnidad.map(brand => {
                                    return  <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('unidad', brand.code, '')}>
                                                {brand.brand} ({brand.times})
                                            </dd>
                                })}
                            </dl>
                        </ul>
                    } */}
                    {/* Fábricas */}
                    {/* {(dataCategories && dataCategories.itemsFacilities.length > 0) && 
                        <h5 className="mt-md-4 font-weight-bold TituloCategoria" >Fábricas</h5>
                    }
                    {(dataCategories && dataCategories.itemsFacilities.length > 0) && 
                        <ul className = "mt-2 SubCategorias" style={{paddingLeft:"12px"}}>
                            <dl>
                                {dataCategories.itemsFacilities.map(facility => {
                                    return  <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('fabrica', facility.facility, '')}>
                                                {facility.facility} ({facility.times})
                                            </dd>
                                })}
                            </dl>
                        </ul>
                    } */}
                    {/* Aparatos */}
                    {/* {(dataCategories && dataCategories.itemsDevices.length > 0) && 
                        <h5 className="mt-md-4 font-weight-bold TituloCategoria">Aparatos</h5>
                    }
                    {(dataCategories && dataCategories.itemsDevices.length > 0) && 
                        <ul className = "mt-2 SubCategorias" style={{paddingLeft:"12px"}}>
                            <dl>
                                {dataCategories.itemsDevices.map(device => {
                                    return  <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('aparato', device.device, '')}>
                                                {device.device} ({device.times})
                                            </dd>
                                })}
                            </dl>
                        </ul>
                    } */}
                    {/* Refacciones */}
                    {/* {(dataCategories && dataCategories.itemsSpareParts.length > 0) && 
                        <h5 className="mt-md-4 font-weight-bold TituloCategoria">Refacciones</h5>
                    }
                    {(dataCategories && dataCategories.itemsSpareParts.length > 0) && 
                        <ul className = "mt-2 SubCategorias" style={{paddingLeft:"12px"}}>
                            <dl>
                                {dataCategories.itemsSpareParts.map(part => {
                                    return  <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('refaccion', part.part, '')}>
                                                {part.part} ({part.times})
                                            </dd>
                                })}
                            </dl>
                        </ul>
                    } */}
                    {/* Precios */}
                    {/* {(dataCategories && dataCategories.pricesSideBar) && 
                        <h5 className="mt-md-4 font-weight-bold TituloCategoria">Precios</h5>
                    }
                    {(dataCategories && dataCategories.pricesSideBar) && 
                        <ul className = "mt-2 SubCategorias" style={{paddingLeft:"12px"}}>
                            <dl>
                                <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('precio', dataCategories.pricesSideBar.min, '')}>
                                    Hasta ${(dataCategories.pricesSideBar.min).toFixed(2)}
                                </dd>
                                {(dataCategories.pricesSideBar.min != dataCategories.pricesSideBar.max) && 
                                    <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('precio', dataCategories.pricesSideBar.min, dataCategories.pricesSideBar.max)}>
                                        Entre ${(dataCategories.pricesSideBar.min).toFixed(2)} - ${(dataCategories.pricesSideBar.max).toFixed(2)}
                                    </dd>
                                }
                                <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('precio', '', dataCategories.pricesSideBar.max)}>
                                    Desde ${(dataCategories.pricesSideBar.max).toFixed(2)}
                                </dd>
                            </dl>
                        </ul>
                    } */}
                    {/* Stock */}
                    {/* {(dataCategories && dataCategories.stock) && 
                        <h5 className="mt-md-4 font-weight-bold TituloCategoria">Existencias</h5>
                    } */}
                    {/* {(dataCategories && dataCategories.stock) && 
                        <ul className = "mt-2 SubCategorias">
                            <dl>
                                {(dataCategories.stock.available !== 0) &&
                                    <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('stock', 'A', '')}>
                                        Disponibles {(dataCategories.stock.available)}
                                    </dd>
                                }
                                {(dataCategories.stock.missing !== 0) &&
                                    <dd className = 'linkFilter' onClick = {() => this.uniqueFilter('stock', 'B', '')}>
                                        Agotados {(dataCategories.stock.missing)}
                                    </dd>
                                }
                            </dl>
                        </ul>
                    } */}
                    <div className="modal fade" id="filterCategoriesModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{border: "none", textAlign: 'center'}}>
                        <div className="modal-dialog modal-lg" role="document" style={{margin: '1.75rem auto'}}>
                            <div className="modal-content">
                                <div className="modal-header" style={{background: config.navBar.iconColor}}>
                                    <h5 className="modal-title" style={{color: config.navBar.textColor2}}>Otras categorías</h5>
                                    <button type="button" style={{color: config.navBar.textColor2}} className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body bg3">
                                    <div className = 'row justity-content-center'>
                                    <div className = 'col-md-6'>
                                        {dataCategories && dataCategories.itemsCategories.length > 0 && dataCategories.itemsCategories.map((category, index) => {
                                            if(index >= limitNumber && index <= twoColumns){
                                                if(category.category.includes(',')){
                                                    let categoryNameArray = category.categoryName.split(',');
                                                    let length = categoryNameArray.length;
                                                    let containerReturn = [];
                                                    for (let i = 0; i < categoryNameArray.length; i++) {
                                                        let dinamicCategory = categoryNameArray[i].substring(0, categoryStringLimiter);
                                                        containerReturn.push(<span>
                                                            {(i == 0) && dinamicCategory}
                                                            {((i > 0 && i < (length - 1))) && '/' + dinamicCategory}
                                                            {(i == (length - 1)) && <span className='linkFilter mr-md-2' onClick = {() => this.uniqueFilter('categorias', category.category, '')}>/{dinamicCategory}</span>}
                                                            {(i == (length - 1)) && <span className='linkFilter mr-md-2' onClick = {() => this.uniqueFilter('categorias', category.category, '')}>({category.times})</span>}
                                                            </span>);
                                                    }
                                                    containerReturn.push(<br/>);
                                                    containerReturn.push(<br/>);
                                                    return containerReturn;
                                                } else {
                                                    let containerReturn = [];
                                                    containerReturn.push(<span className = 'linkFilter mr-md-2' onClick = {() => this.uniqueFilter('categorias', category.category, '')}>
                                                            {category.categoryName} ({category.times})
                                                        </span>);
                                                    containerReturn.push(<br/>);
                                                    containerReturn.push(<br/>);
                                                    return containerReturn;
                                                }
                                            } 
                                        })}
                                    </div>
                                    <div className = 'col-md-6'>
                                        {dataCategories && dataCategories.itemsCategories.length > 0 && dataCategories.itemsCategories.map((category, index) => {
                                            if(index >= limitNumber && index > twoColumns){
                                                if(category.category.includes(',')){
                                                    let categoryNameArray = category.categoryName.split(',');
                                                    let length = categoryNameArray.length;
                                                    let containerReturn = [];
                                                    for (let i = 0; i < categoryNameArray.length; i++) {
                                                        let dinamicCategory = categoryNameArray[i].substring(0, categoryStringLimiter);
                                                        containerReturn.push(<span>
                                                            {(i == 0) && dinamicCategory}
                                                            {((i > 0 && i < (length - 1))) && '/' + dinamicCategory}
                                                            {(i == (length - 1)) && <span className='linkFilter mr-md-2' onClick = {() => this.uniqueFilter('categorias', category.category, '')}>/{dinamicCategory}</span>}
                                                            {(i == (length - 1)) && <span className='linkFilter mr-md-2' onClick = {() => this.uniqueFilter('categorias', category.category, '')}>({category.times})</span>}
                                                            </span>);
                                                    }
                                                    containerReturn.push(<br/>);
                                                    containerReturn.push(<br/>);
                                                    return containerReturn;
                                                } else {
                                                    let containerReturn = [];
                                                    containerReturn.push(<span className = 'linkFilter mr-md-2' onClick = {() => this.uniqueFilter('categorias', category.category, '')}>
                                                            {category.categoryName} ({category.times})
                                                        </span>);
                                                    containerReturn.push(<br/>);
                                                    containerReturn.push(<br/>);
                                                    return containerReturn;
                                                }
                                            } 
                                        })}
                                    </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                                </div>
                            </div>
                        </div>
                    </div>
            
                </div>
            );
        }
    }
}

const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer,
        shoppingCartReducer: store.ShoppingCartReducer,
        itemsReducer: store.ItemsReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setShoppingCart: value => dispatch ({type: DISPATCH_ID.SHOPPING_CART_SAVE_CART, value}),
        setItemsFilterSearch: value => dispatch ({type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value}),
        setNextPage:  value => dispatch ({type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value}),
        searchByDashOption: value => dispatch ({type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_DASH_OPTION, value}),
        setItemsFilters: value => dispatch({type: DISPATCH_ID.ITEMS_SET_UNIQUE_FILTER, value}), 

    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SideBarItems);